export default __webpack_public_path__ + "static/wealth-44f8f2d18daa4d9d2cc997065939b10f.svg";